<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container d-flex flex-column">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div dir id="studyContainer" class="modal-container">
              <div id="study-body">
                <div id="container">
                  <transition :name="mainTransitionName" mode="out-in">
                    <div id="videoContainer">
                      <div class="pdl-16 pdr-16 pdb-16 pdt-16 bg-primary iframeContainer">
                        <iframe :src="linkUrl" id="contentsIframe"></iframe>
                      </div>
                      <div
                        class="mt-4 d-landscape-block lesson-name t-body4"
                      >{{lessonName}}</div>

                      <button id="btnClose" class="mdc-button"></button>
                      <button id="btnQnA" class="d-landscape-none mdc-button" v-if="isPortrait"></button>
                      <div id="socialContainer" class="mt-2" :style="isPortrait=== true?'right:45px':'' ">
                          <button id="btnHeart"  class="typography--b4 mdc-button"
                                  v-bind:class="{'active': likes}">
                          </button>
                          <button id="btnBookmark" @click="onBookmark" @keypress="onBookmark" class="typography--b4 mdc-button"
                                  v-bind:class="{'active': clipping}">
                          </button>
                      </div>

                      <div id="bookmarkIcon" ref="bookmarkIcon">
                          <div>
                              <img v-if="clipping" src="../../assets/bookmark-on.svg" alt="Bookmark On"/>
                              <img v-else src="../../assets/bookmark.svg" alt="Bookmark Off"/>
                          </div>
                      </div>

                      <div id="likeIcon" ref="likeIcon">
                          <div>
                              <img v-if="likes" src="../../assets/heart-on.svg" alt="Like On"/>
                              <img v-else src="../../assets/heart.svg" alt="Like Off"/>
                          </div>
                      </div>
                      <button id="btnPaging" class="d-landscape-none mdc-button">
                        <span>
                          {{$t('1117')}}
                          <!-- Paging -->
                        </span>
                      </button>
                    </div>
                  </transition>
                  <transition :name="mainTransitionName" mode="out-in">
                    <div  class="d-portrait-none" id="videoButtonsContainer">
                      <button class="typography--b3 mdc-button">
                        {{$t('1053')}}
                        <!-- Ask a question -->
                      </button>
                      <button @click="onTogglePlaylist()" @keypress="onTogglePlaylist()" tabindex="0" class="typography--b3 mdc-button">
                        {{$t('1054')}}
                        <!-- Lectures -->
                      </button>
                    </div>
                  </transition>
                  <!-- 진도율 / 좋아요 / 북마크 영역 -->

                  <transition :name="mainTransitionName" mode="out-in">
                    <div v-show="isLecturesVisible" id="playlistContainer">
                      <div class="title">
                        <button @click="onTogglePlaylist()" @keypress="onTogglePlaylist()" id="btnPlaylistClose" class="mdc-button" tabindex="0"></button>
                        <span
                          class="typography--s4 text-center"
                          :class="{'typography--b4': !showLectureList, 'text-left': !showLectureList}"
                        >{{showLectureList ? `${$t('1086')}` : `${$t('1045')}: ${nextLessonName}`}}</span>
                        <!-- <span v-else id="lecturesTitle" class="typography--b4 text-left">Next: {{ nextLessonName }}</span> -->
                        <button @click="onTogglePlaylist()" @keypress="onTogglePlaylist()" id="btnPlaylistToggle" class="mdc-button" tabindex="0"></button>
                        <div class="clearfix"></div>
                      </div>
                      <div class="lectures-list">
                        <ul class="mt-0" id="learnLessionList">
                          <li
                            v-for="(lesson, index) in lessonsList"
                            :key="index"
                            @click="moveNextLesson(lesson,index)" @keypress="moveNextLesson(lesson,index)" tabindex="0"
                            :class="{'active': lesson.progressionId === currentProgressionId}"
                          >
                            <!-- {{lesson}} -->
                            <div
                              class="d-inline-block"
                              :class="lesson.status.value === 'OPENED' ? '' : 'color-secondary'"
                            >
                              <span
                                class="typography--b3 d-block"
                                :class="{'t-color-mainBtn': lesson.progressionId === currentProgressionId}"
                              >{{lesson.name}}</span>
                              <span
                                class="typography--ht-helper d-block mt-1"
                              >{{lesson.contentsType.text}}</span>
                            </div>
                          </li>
                        </ul>
                        <!-- <lessons-list :lessonsList="lessonsList" :currentProgressionId="currentProgressionId"></lessons-list> -->
                      </div>
                    </div>
                  </transition>
                  <div id="resizeContainer">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * HTML 학습창
 *
 * @author minkyoung.park@emcast.com
 * @author
 * @since 2019.09
 */

// Components/Mixin/Extend/API 선언
// import "@/scss/study.scss";
// import "@/css/study.css";

// import learnApi from '@/api/learnApi.js'
// import ImageSlider from '@/components/study/slider/ImageSlider.vue'

//import HtmlType from "@/components/study/HtmlType.vue"
import htmlvideo from "@/json/htmlvideo.json";
import { htmlTypeMixins } from "../../mixins/htmlType.js";
import {MDCRipple} from '@material/ripple'
export default {
  data() {
    return {
      linkUrl: "/HTML5/contents/index.html",
      lessonData: null,
      myJson: htmlvideo,
      lessonName: "",
      lessonsList: [],
      nextLessonName: "",
      currentProgressionId: "",
      rate: 0,
      last: 0,
      recent: 0,
      time: 0,
      currentSlide: 0,
      showLectureList: false,
      isPortrait :  true,
      // 북마크 좋아요 관려 데이터(like & bookmark data)
      isLiked: false,
      isBookmarked: false,
      likes: false,
      likesCount: 0,
      clipping: false,
      clippingCount: 0,

      isAllPages: false,
      isScroll: false,
      isTimeline: false,
      isExpand: false,
    };
  },
  mixins: [htmlTypeMixins],
 
  mounted() {
    this.lessonName = "Digital Media Analytics Social Media M...";
    this.rate = 76;
    this.currentProgressionId = 1;
    this.lessonsList = htmlvideo;
    //this.linkUrl = htmlvideo
    this.fetchLectureList("", "");
    window.addEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
    this.setMaterialUi()
    
  },
  methods: {
    moveNextLesson(lesson, index) {
      if (lesson.status.value === "OPENED") {
        this.linkUrl = lesson.linkUrl;
        this.fetchLectureList(lesson, index);
      }
    },

    fetchLectureList(lesson, index) {
      let responseData = null;

      //차시 정보

      // 과정의 차시 정보만 병합(Merging only lesson data from the course)

      this.lessonsList = htmlvideo;

      // 다음 차시명 설정(set next lesson)
      let currentLessonIndex = _.findIndex(this.lessonsList, (lesson) => {
        return lesson.progressionId === this.currentProgressionId;
      });
      let nextLessonIndex =
        this.lessonsList.length > 1 && this.lessonsList.length > index
          ? (index += 1)
          : -1;
      if (nextLessonIndex) {
        this.nextLesson = this.lessonsList[nextLessonIndex];
        this.nextLessonName = this.lessonsList[nextLessonIndex].name;
      }
    },
    handleOrientationChange() {
      const orientation = window.screen.orientation.type
      if (orientation === "portrait-primary") {
         this.isPortrait === true
      } else if (orientation === "landscape-primary") {
        this.isPortrait === false
      }
    },
    setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
  },
};
</script>
<!--<style scoped src="../../css/html.css"></style>-->
<style scoped>
#studyContainer #socialContainer {
    position: absolute !important;
    text-align: right !important;
}
html[dir="rtl"] #studyContainer #socialContainer {
    text-align: left !important;
}
#studyContainer #btnHeart{
  margin-right: 0rem !important;
}
html[dir="rtl"] #studyContainer #btnHeart{
  margin-left: 0rem !important;
}
</style>